module.exports = __webpack_public_path__ + "static/media/spinebuzz-1.03c46683.jpg";